<template>
  <div id="home">
    <header-section :subnav_show="false" :change_color="true"></header-section>
    <hero-section></hero-section>

    <div class="container">
      <div class="services">
        <!-- data-aos="fade-up" -->
        <div class="section-title" >
          <h2>智能制造</h2>
          <p>MANUFACTURE</p>
        </div>
        <el-row :gutter="15">
          <el-col>
            <div class="icon-box" data-aos="zoom-in" data-aos-delay="50">
              <div class="icon"><i class="el-icon-odometer"></i></div>
              <h4 class="title">
                <a href="javascript:void(0)" style="cursor: default">
                  电子整机制造
                </a>
              </h4>
              <p class="description">
                高端电子产品制造生产线，全自动贴装设备、AOI检测技术、FCT平台检测平台、ICT自动检测系统等智能化设备，制造出品质稳定、性能优良的电子产品。
              </p>
            </div>
          </el-col>
          <el-col>
            <div class="icon-box" data-aos="zoom-in" data-aos-delay="100">
              <div class="icon"><i class="el-icon-cpu"></i></div>
              <h4 class="title">
                <a href="javascript:void(0)" style="cursor: default">
                  传感器精密制造
                </a>
              </h4>
              <p class="description">
                优级材质、高精密数控加工设备、优良组装制造工艺制造出的产品，满足不同应用领域的客户需求，准确度高，性能稳定可靠，长期稳定运行。
              </p>
            </div>
          </el-col>
          <el-col>
            <div class="icon-box" data-aos="zoom-in" data-aos-delay="150">
              <div class="icon"><i class="el-icon-set-up"></i></div>
              <h4 class="title">
                <a href="javascript:void(0)" style="cursor: default">
                  集成化仪器
                </a>
              </h4>
              <p class="description">
                高标准模块化检测手段，逐级提升质量要求，组成优良的集成化整机，产品运行稳定，一致性好，性价比高。
              </p>
            </div>
          </el-col>
          <el-col>
            <div class="icon-box" data-aos="zoom-in" data-aos-delay="200">
              <div class="icon"><i class="el-icon-setting"></i></div>
              <h4 class="title">
                <a href="javascript:void(0)" style="cursor: default">
                  应用装备制造
                </a>
              </h4>
              <p class="description">
                技术指标分析检测、产能管理、质量追溯，以及整个制造过程的全局掌控。透过与数字化结合，真正赋能产品质量管理、提升产能、降低损耗、实现智能制造。
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- solutions解决方案 -->
    <div class="container">
      <div class="solutions" data-aos="fade-up">
        <div class="section-title">
          <h2>解决方案</h2>
          <p>SOLUTIONS</p>
        </div>
        <el-row :gutter="15" class="el-row">
          <el-col :span="8" v-for="(bean, k) in solution_list" :key="k">
            <div class="card" :style="'background: url(' + bean.image + ')'">
              <div class="card-body">
                <h5 class="card-title">
                  <a :href="'/solution/detail/' + bean.id">{{ bean.title }}</a>
                </h5>
                <p class="card-text">
                  <!-- {{bean.summary.replace(/<[^>]+>/g,'') | ellipsis(40)}} -->
                  <a :href="'/solution/detail/' + bean.id">
                    {{
                      bean.summary.replace(/&lt;[^&gt;]+&gt;/g, "")
                        | ellipsis(40)
                    }}
                  </a>
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- end solutions解决方案 -->
    <!-- 典型案例 -->
    <div id="cases" class="container">
      <div class="cases" data-aos="fade-up">
        <div class="section-title">
          <h2>客户案例</h2>
          <p>CASES</p>
        </div>
        <el-row :gutter="15" class="el-row">
          <el-col
            class="case-list-item"
            :span="12"
            v-for="(bean, k) in case_list"
            :key="k">
            <div class="case">
              <div class="pic"><img :src="bean.image" alt="" /></div>
              <div class="case-info">
                <h4>
                  <a :href="'/case/detail/' + bean.id" target="_blank">
                    {{ bean.title }}
                  </a>
                </h4>
                <div v-html="bean.summary" style="height: 100px"></div>
                <div class="more">
                  <a :href="'/case/detail/' + bean.id" target="_blank">
                    <i class="bi bi-arrow-right-short"></i>
                    查看详情
                  </a>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- End 典型案例 -->

    <!-- ======= 核心优势 Section ======= -->
    <div id="advantage" class="advantage section-bg">
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <h2>核心优势</h2>
          <p>ADVANTAGE</p>
        </div>

        <el-row :gutter="15" class="el-row">
          <el-col :span="8">
            <div class="icon-box iconbox-blue">
              <div class="icon">
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 600 600"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    stroke="none"
                    stroke-width="0"
                    fill="#f5f5f5"
                    d="M300,521.0016835830174C376.1290562159157,517.8887921683347,466.0731472004068,529.7835943286574,510.70327084640275,468.03025145048787C554.3714126377745,407.6079735673963,508.03601936045806,328.9844924480964,491.2728898941984,256.3432110539036C474.5976632858925,184.082847569629,479.9380746630129,96.60480741107993,416.23090153303,58.64404602377083C348.86323505073057,18.502131276798302,261.93793281208167,40.57373210992963,193.5410806939664,78.93577620505333C130.42746243093433,114.334589627462,98.30271207620316,179.96522072025542,76.75703585869454,249.04625023123273C51.97151888228291,328.5150500222984,13.704378332031375,421.85034740162234,66.52175969318436,486.19268352777647C119.04800174914682,550.1803526380478,217.28368757567262,524.383925680826,300,521.0016835830174"></path>
                </svg>
                <i class="el-icon-cpu"></i>
              </div>
              <h4>高新技术企业</h4>
              <p>
                连续多年被认定为“优秀高新技术企业”，并被被评为“创新型企业”。
              </p>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="icon-box iconbox-orange">
              <div class="icon">
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 600 600"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    stroke="none"
                    stroke-width="0"
                    fill="#f5f5f5"
                    d="M300,582.0697525312426C382.5290701553225,586.8405444964366,449.9789794690241,525.3245884688669,502.5850820975895,461.55621195738473C556.606425686781,396.0723002908107,615.8543463187945,314.28637112970534,586.6730223649479,234.56875336149918C558.9533121215079,158.8439757836574,454.9685369536778,164.00468322053177,381.49747125262974,130.76875717737553C312.15926192815925,99.40240125094834,248.97055460311594,18.661163978235184,179.8680185752513,50.54337015887873C110.5421016452524,82.52863877960104,119.82277516462835,180.83849132639028,109.12597500060166,256.43424936330496C100.08760227029461,320.3096726198365,92.17705696193138,384.0621239912766,124.79988738764834,439.7174275375508C164.83382741302287,508.01625554203684,220.96474134820875,577.5009287672846,300,582.0697525312426"></path>
                </svg>
                <i class="el-icon-star-off"></i>
              </div>
              <h4>核心技术、知识产权</h4>
              <p>
                拥有自主知识产权。自主知识产权70多项，其中发明技术7项，软著40项，发明技术5项目
              </p>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="icon-box iconbox-pink">
              <div class="icon">
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 600 600"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    stroke="none"
                    stroke-width="0"
                    fill="#f5f5f5"
                    d="M300,541.5067337569781C382.14930387511276,545.0595476570109,479.8736841581634,548.3450877840088,526.4010558755058,480.5488172755941C571.5218469581645,414.80211281144784,517.5187510058486,332.0715597781072,496.52539010469104,255.14436215662573C477.37192572678356,184.95920475031193,473.57363656557914,105.61284051026155,413.0603344069578,65.22779650032875C343.27470386102294,18.654635553484475,251.2091493199835,5.337323636656869,175.0934190732945,40.62881213300186C97.87086631185822,76.43348514350839,51.98124368387456,156.15599469081315,36.44837278890362,239.84606092416172C21.716077023791087,319.22268207091537,43.775223500013084,401.1760424656574,96.891909868211,461.97329694683043C147.22146801428983,519.5804099606455,223.5754009179313,538.201503339737,300,541.5067337569781"></path>
                </svg>
                <i class="el-icon-setting"></i>
              </div>
              <h4>研.产.销</h4>
              <p>
                拥有自己研发团队，并在传感器、仪器、自控集成等硬件制造方面，拥有规模化的自动生产线，以及全球化的销售网络。
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="el-row" v-if="false">
          <el-col :span="8">
            <div class="icon-box iconbox-yellow">
              <div class="icon">
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 600 600"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    stroke="none"
                    stroke-width="0"
                    fill="#f5f5f5"
                    d="M300,503.46388370962813C374.79870501325706,506.71871716319447,464.8034551963731,527.1746412648533,510.4981551193396,467.86667711651364C555.9287308511215,408.9015244558933,512.6030010748507,327.5744911775523,490.211057578863,256.5855673507754C471.097692560561,195.9906835881958,447.69079081568157,138.11976852964426,395.19560036434837,102.3242989838813C329.3053358748298,57.3949838291264,248.02791733380457,8.279543830951368,175.87071277845988,42.242879143198664C103.41431057327972,76.34704239035025,93.79494320519305,170.9812938413882,81.28167332365135,250.07896920659033C70.17666984294237,320.27484674793965,64.84698225790005,396.69656628748305,111.28512138212992,450.4950937839243C156.20124167950087,502.5303643271138,231.32542653798444,500.4755392045468,300,503.46388370962813"></path>
                </svg>
                <i class="el-icon-magic-stick"></i>
              </div>
              <h4><a href="">质量管理体系</a></h4>
              <p>
                质量品管方面规范执行ISO9001、ISO14001等体系认证，坚持不懈的追求领跑行业制造之先锋。
              </p>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="icon-box iconbox-red">
              <div class="icon">
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 600 600"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    stroke="none"
                    stroke-width="0"
                    fill="#f5f5f5"
                    d="M300,532.3542879108572C369.38199826031484,532.3153073249985,429.10787420159085,491.63046689027357,474.5244479745417,439.17860296908856C522.8885846962883,383.3225815378663,569.1668002868075,314.3205725914397,550.7432151929288,242.7694973846089C532.6665558377875,172.5657663291529,456.2379748765914,142.6223662098291,390.3689995646985,112.34683881706744C326.66090330228417,83.06452184765237,258.84405631176094,53.51806209861945,193.32584062364296,78.48882559362697C121.61183558270385,105.82097193414197,62.805066853699245,167.19869350419734,48.57481801355237,242.6138429142374C34.843463184063346,315.3850353017275,76.69343916112496,383.4422959591041,125.22947124332185,439.3748458443577C170.7312796277747,491.8107796887764,230.57421082200815,532.3932930995766,300,532.3542879108572"></path>
                </svg>
                <i class="el-icon-trophy"></i>
              </div>
              <h4><a href="">欧盟CE认证</a></h4>
              <p>
                欧盟CE认证、欧盟CE认证、欧盟CE认证、欧盟CE认证、欧盟CE认证、。
              </p>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="icon-box iconbox-teal">
              <div class="icon">
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 600 600"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    stroke="none"
                    stroke-width="0"
                    fill="#f5f5f5"
                    d="M300,566.797414625762C385.7384707136149,576.1784315230908,478.7894351017131,552.8928747891023,531.9192734346935,484.94944893311C584.6109503024035,417.5663521118492,582.489472248146,322.67544863468447,553.9536738515405,242.03673114598146C529.1557734026468,171.96086150256528,465.24506316201064,127.66468636344209,395.9583748389544,100.7403814666027C334.2173773831606,76.7482773500951,269.4350130405921,84.62216499799875,207.1952322260088,107.2889140133804C132.92018162631612,134.33871894543012,41.79353780512637,160.00259165414826,22.644507872594943,236.69541883565114C3.319112789854554,314.0945973066697,72.72355303640163,379.243833228382,124.04198916343866,440.3218312028393C172.9286146004772,498.5055451809895,224.45579914871206,558.5317968840102,300,566.797414625762"></path>
                </svg>
                <i class="el-icon-data-line"></i>
              </div>
              <h4><a href="">强化优势，跨越发展</a></h4>
              <p>
                ...产、学、研.....团队建设.....股票简称：科瑞达，股票代码：832189
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- End 核心优势 Section -->

    <!-- 资质荣誉 -->
    <!-- <div id="advantage" class="advantage section-bg">
			<div class="container" data-aos="fade-up">
				<div class="section-title">
					<h2>资质荣誉</h2>
					<p>QUALIFICATION HONOR</p>
				</div>
				<div class="swiper mySwiper">
				    <div class="swiper-wrapper">
						<el-carousel :interval="4000" arrow="never" height="300">
							<el-carousel-item v-for="(item, index) in honors" :key="index">
								<template v-for="(son,sonindex) in item.page">
									<el-image
									:key="sonindex"
									    :src="son.url"
									    :preview-src-list="[son.url]">
									</el-image>
								</template>
							</el-carousel-item>
						</el-carousel>
				    </div>
				    <div class="swiper-pagination"></div>
				</div> -->
    <!-- <swiper
					ref="mySwiper" 
					v-bind:options="swiperOptions"
				    :slides-per-view="3"
				    :space-between="50"
				    @swiper="onSwiper"
				    @slideChange="onSlideChange"
				  >
				    <swiper-slide><img src="@/static/img/home/certificates/1.jpg" /></swiper-slide>
				    <swiper-slide><img src="@/static/img/home/certificates/2.jpg" /></swiper-slide>
				    <swiper-slide><img src="@/static/img/home/certificates/3.jpg" /></swiper-slide>
				  </swiper> -->
    <!-- </div>
		</div> -->

    <!-- 我们的实力 -->
    <!-- <div id="advantage" class="advantage section-bg">
			<div class="container" data-aos="fade-up">
				<div class="section-title">
					<h2>公司优势</h2>
					<p>COMPANY STRENGTHS</p>
				</div>
				
				<div class="advantages">
					<div>
						<div>
							<img src="@/static/img/home/strengths/strength1.jpg" />
						</div>
						<div>
							产品优势
						</div>
						<div>
							公司拥有一套完整的研发、生产、检测、质量控制体系，拥有独立的研发生产基地和创新平台：EMC电磁兼容实验室、化学实验室、传感器工程技术研究中心。
						</div>
					</div>
					<div>
						<div>
							<img src="@/static/img/home/strengths/strength2.jpg" />
						</div>
						<div>
							技术优势
						</div>
						<div>
							由于其专业性和可靠的质量，CREATEC在线水质分析仪器的市场份额稳步上升。我们的产品已出口到全球66个国家，并逐步建立区域合作伙伴关系。
						</div>
					</div>
					<div>
						<div>
							<img src="@/static/img/home/strengths/strength3.jpg" />
						</div>
						<div>
							服务优势
						</div>
						<div>
							CREATEC在北京、上海、广东、山东设有分公司，并建立了完善的售后服务体系，为国内热门工业区的轻、重、环、民生提供便捷高效的技术服务！
						</div>
					</div>
				</div>
			</div>
		</div> -->
    <!-- 新闻动态 -->
    <!-- <div data-aos="fade-up" data-aos-duration="1200" data-aos-offset="50"
            class="index_seven_info aos-init aos-animate">
            <div class="info_title">新闻中心</div>
            <div class="info_sub_div"><a href="https://www.cosmoplat.com/platform/news" target="_blank"
                    rel="noopener noreferrer" class="info_sub_title">查看更多<span><i
                            class="el-icon-arrow-right"></i></span></a></div>
            <div class="nap-container">
                <div class="info_container"><a data-aos="fade-right" data-aos-duration="1000" data-aos-offset="100"
                        target="_blank" rel="noopener noreferrer" href="/news/detail/?newsid=6806"
                        class="info_left_con aos-init aos-animate"><img class="info_left_img"
                            src="https://hd-oss.cosmoplat.com/hdCosmo25%3Acosmoplat/202301/0dd00f13-a6c0-4dad-b2a5-3e88d8dc9ae1.jpg">
                        <div class="info_left_half">
                            <div class="info_left_title">发现工业之美，“领潮而行·中央媒体零距离探访工业互联网平台企业行”走进卡奥斯</div>
                            <div class="info_left_detail">
                                12月15日，由工业和信息化部信息技术发展司指导，工业互联网平台创新合作中心牵头主办的“领潮而行·中央媒体零距离探访工业互联网平台企业行”来到青岛，由人民网、科技日报、大众日报、齐鲁晚报、凤凰网、界面等近20家媒体组成的媒体团参观了卡奥斯COSMOPlat生态展。通过对工业元宇宙、智能+5G大规模定制虚实融合示范验证平台沉浸式体验和奇瑞、工业良田等赋能案例的分享，媒体团近距离感受“双跨”平台卡奥斯COSMOPlat的科技创新和赋能能力，深度了解工业互联网赋能下的制造业发展新模式和新路径。
                            </div>
                            <div class="info_left_date">2023-01-04 14:31:16</div>
                        </div>
                    </a>
                    <div class="info_right_con"><a data-aos="fade-down" data-aos-duration="800" data-aos-offset="30"
                            data-aos-delay="100" target="_blank" rel="noopener noreferrer"
                            href="/news/detail/?newsid=6800" class="info_right_item aos-init aos-animate">
                            <div class="info_right_title">践行企业使命，彰显品牌温度！卡奥斯获中国互联网行业自律贡献和公益奖</div>
                            <div class="info_right_detail">
                                近日，“2021－2022年度中国互联网行业自律贡献和公益奖”颁奖仪式在第二十一届中国互联网大会上举行。其中，卡奥斯COSMOPlat凭借自我规范的行业自律、积极抗“疫”的社会责任以及在用户价值创造、双碳目标践行等方面的突出表现，获评“2021-2022年度中国互联网行业自律贡献和公益奖”。
                            </div>
                            <div class="info_right_date">2023-01-04 13:57:46</div>
                        </a><a data-aos="fade-down" data-aos-duration="800" data-aos-offset="30" data-aos-delay="200"
                            target="_blank" rel="noopener noreferrer" href="/news/detail/?newsid=6798"
                            class="info_right_item aos-init aos-animate">
                            <div class="info_right_title">数字经济新坐标，易观联合卡奥斯发布产业数字化成熟度指数</div>
                            <div class="info_right_detail">
                                12月15日，2022世界工业互联网产业大会“工赋山东数字经济创新发展峰会”在青岛举行。会上，易观分析联合卡奥斯COSMOPlat共同打造的“2022中国产业数字化发展成熟度指数”正式发布，将成为新时期洞悉数字经济规律、度量高质量发展的“新密码”。
                            </div>
                            <div class="info_right_date">2023-01-04 13:52:40</div>
                        </a><a data-aos="fade-down" data-aos-duration="800" data-aos-offset="30" data-aos-delay="300"
                            target="_blank" rel="noopener noreferrer" href="/news/detail/?newsid=6794"
                            class="info_right_item aos-init aos-animate">
                            <div class="info_right_title">工赋山东”再提速！卡奥斯点亮城市经济发展“风向标</div>
                            <div class="info_right_detail">
                                12月15日，在2022世界工业互联网产业大会举办期间，工赋山东数字经济创新发展峰会也在青岛隆重召开。会上，依托卡奥斯COSMOPlat搭建的胶东半岛五市区域一体化工业互联网公共服务平台正式上线，标志着全省在推进“工赋山东”已取得关键阶段性成果。
                            </div>
                            <div class="info_right_date">2022-12-16 09:38:34</div>
                        </a><a data-aos="fade-down" data-aos-duration="800" data-aos-offset="30" data-aos-delay="400"
                            target="_blank" rel="noopener noreferrer" href="/news/detail/?newsid=6792"
                            class="info_right_item aos-init aos-animate">
                            <div class="info_right_title">助力工业企业数字化转型！卡奥斯BaaS数字工业操作系统重磅发布</div>
                            <div class="info_right_detail">
                                12月15日，2022世界工业互联网产业大会在青岛开幕。大会开幕式上，卡奥斯BaaS数字工业操作系统正式发布，为全方位推动工业数字化转型提供了工业互联网赋能下的新工具、新抓手。
                            </div>
                            <div class="info_right_date">2022-12-16 09:13:12</div>
                        </a><a data-aos="fade-down" data-aos-duration="800" data-aos-offset="30" data-aos-delay="500"
                            target="_blank" rel="noopener noreferrer" href="/news/detail/?newsid=6784"
                            class="info_right_item aos-init aos-animate">
                            <div class="info_right_title">智能制造能力成熟度（CMMM®）新风向|26地出台政策支持</div>
                            <div class="info_right_detail">
                                随着智能制造成为制造业高质量发展的主攻方向，国家先后出台政策，鼓励企业提升公共服务能力，开展智能制造能力成熟度评估服务等。其中，智能制造能力成熟度评估所参考的两项标准，即GB/T
                                39116-2020《智能制造能力成熟度模型》和GB/T
                                39117-2020《智能制造能力成熟度评估方法》，目前已进入全面应用推广阶段，形成了政策引导、路径指引和能力提升的协同推进局面。</div>
                            <div class="info_right_date">2022-11-15 11:26:43</div>
                        </a></div>
                </div>
            </div>
        </div> -->
    <!-- end 新闻动态 -->
    <!--工厂-->
    <div class="mt-5" data-aos="fade-right">
      <div class="paba_left_rigt_main">
        <div class="paba_left_main"></div>
        <div class="paba_rigt_main">
          <div class="pcba_list">
            <div class="pcba_list_left">
              <div class="chname">智慧工厂</div>
              <div class="enname">Smart Factory</div>
              <!--                    <div class="hline"></div>-->
              <div class="pcba_info">
                在仪表、传感器、集成化产品等硬件制造方面运用现代先进制造手段，拥有规模化的自动生产线，在行业中率先实现了对传感器、数字化感知发送器、现场处理模块、整机产品的智能化自动检测。
                集数据采集、分析于一体，配备行业专业的车间及线体数据看板，实时获取生产过程数据，实现对生产设备、物料、生产过程、产品质量的全流程管控，生产制造数字化。
                通过软硬件支持助力企业持续提升智能制造能力，成就产品制造的一致性、重复性、可靠性，以坚持不懈的追求领跑行业制造之先锋。
              </div>
              <!-- <div class="pacb_option">
								<a class="button button_more" href="/about">了解更多</a>
							</div> -->
            </div>
            <img src="@/static/img/home/factory.png" class="pcba_list_img" />
          </div>
        </div>
        <div style="height: 57px"></div>
      </div>
    </div>
    <!--工厂-->

    <!-- ======= 关于我们 Section ======= -->
    <div id="about" class="section-bg">
      <div
        style="width: 100%; padding: 60px 0px; background: rgb(226, 230, 243)">
        <div class="section-title" data-aos="fade-right">
          <h2>关于我们</h2>
          <p>ABOUT US</p>
        </div>

        <div class="row content" data-aos="fade-right">
          <div class="about_us p-4">
            <img src="@/static/img/company/pic1.png" class="about_us_img" />
            <div class="about_us_more">
              <div class="name">关于我们</div>
              <div class="content">
                <div>
                  &nbsp;&nbsp;&nbsp;&nbsp;河北科瑞达仪器科技股份有限公司成立于2006年,专注于水质在线分析仪器和水环保分析仪器，以及各种基于水分析的研发和工程项目运用，拥有自主知识产权。
                </div>
                <div>
                  &nbsp;&nbsp;&nbsp;&nbsp;公司运用水质在线分析核心技术，厚积薄发。构建起感知层、应用层、集成层、网络层等一系列水质安全、环境监测、工业水处理、高效农业等应用技术板块，为电力、石化、冶金、制药、能源、交通、环境、科技农业、水安全、生命科学等涉水领域提供了强有力的技术支撑。
                </div>
                <div>
                  &nbsp;&nbsp;&nbsp;&nbsp;公司目前注册资本4620万元，注册地在国家级高新技术开发区——石家庄高新技术开发区金石工业园区。企业连续多年被认定为“优秀高新技术企业”，并被被评为“创新型企业”。旗下拥有多家子公司从事专业的一线运营。股票简称：科瑞达，股票代码：832189。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ======= 合作伙伴 Section ======= -->
    <div id="about" class="section-bg" style="background: #fff">
      <div
        style="
          width: 1280px;
          padding: 60px 0px;
          background: #fff;
          margin: 0 auto;
        ">
        <div class="section-title" data-aos="fade-right">
          <h2>合作伙伴</h2>
          <p>COOPERATION PARTNERS</p>
        </div>
        <div class="total">
          <el-carousel :interval="5000" arrow="never">
            <el-carousel-item
              v-for="(item, index) in partners"
              :key="index"
              :style="{
                background: 'url(' + item.url + ')',
                backgroundPosition: 'center center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }"></el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer-section :type="'index'"></footer-section>
    <!-- 弹出窗口 -->
    <div v-if="isPopupVisible" class="popup-container">
      <div>
        <img :src="popupImage" alt="Popup Image" />
        <el-button
          @click="isPopupVisible = false"
          class="shut"
          :style="{ color: buttonTextColor }">
          关闭
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderSection from "@/components/public/head.vue";
import HeroSection from "@/components/public/hero.vue";
import FooterSection from "@/components/public/footer.vue";
// import "swiper/swiper-bundle.min.css"
// import Swiper from "swiper/swiper-bundle.js"

export default {
  components: {
    HeaderSection,
    HeroSection,
    FooterSection,
  },
  props: {},
  data() {
    return {
      isPopupVisible: false, // 控制弹出窗口是否可见
      popupImage: require("@/assets/3.jpg"), // 弹出窗口展示的图片路径
      popupTimeout: null, // 用于存储定时器的引用
      buttonTextColor: "white", // 按钮文字颜色
      subnav_show: false,
      solution_list: [],
      case_list: [],

      partners: [
        {
          url: require("@/static/img/home/partner2.jpg"),
        },
        {
          url: require("@/static/img/home/partner1.jpg"),
        },
        {
          url: require("@/static/img/home/partner3.jpg"),
        },
      ],
      //资质荣誉
      honors: [
        {
          page: [
            // {
            // 	url:require('@/static/img/home/certificates/1.jpg')
            // },
            // {
            // 	url:require('@/static/img/home/certificates/2.jpg')
            // },
            {
              url: require("@/static/img/home/certificates/3.jpg"),
            },
            {
              url: require("@/static/img/home/certificates/4.jpg"),
            },
            {
              url: require("@/static/img/home/certificates/5.jpg"),
            },
            {
              url: require("@/static/img/home/certificates/6.jpg"),
            },
          ],
        },
        {
          page: [
            {
              url: require("@/static/img/home/certificates/7.jpg"),
            },
            {
              url: require("@/static/img/home/certificates/8.jpg"),
            },
            {
              url: require("@/static/img/home/certificates/9.jpg"),
            },
            {
              url: require("@/static/img/home/certificates/10.jpg"),
            },
          ],
        },
      ],
    };
  },
  watch: {},
  filters: {
    ellipsis(value, limit) {
      if (!value) return "";
      if (value.length > limit) {
        return value.slice(0, limit) + "...";
      }
      return value;
    },
  },
  methods: {
    onSwiper(swiper) {
      window.console.log(swiper);
    },
    onSlideChange() {
      window.console.log("slide change");
    },
    //获取解决方案
    get_solution_list: function () {
      this.$get(this.$api.getArticleLimitList + "/101/6").then((res) => {
        if (res.code === 0) {
          this.solution_list = res.data;
          //this.loading = false
        } else {
          window.console.log(res.msg);
        }
      });
    },
    //获取解决方案
    get_case_list: function () {
      this.$get(this.$api.getArticleLimitList + "/104/6").then((res) => {
        if (res.code === 0) {
          this.case_list = res.data;
          //this.loading = false
        } else {
          window.console.log(res.msg);
        }
      });
    },
    // 获取首页信息
    // get_index_info:function(){
    //     this.$get(this.$api.getHomePageInfo).then(res=>{
    //         // console.log(res.data);
    //         this.banner_list = res.data.banner;
    //         this.banner_bottom_adv = res.data.brandList;
    //         this.orgRecomList = res.data.orgRecomList;
    //         this.hotRecomList = res.data.hotRecomList;
    //     });
    // },
    // 显示弹出窗口的方法
    showPopup() {
      this.isPopupVisible = true;
      // 设置3秒后自动关闭弹出窗口
      this.popupTimeout = setTimeout(() => {
        this.isPopupVisible = false;
        clearTimeout(this.popupTimeout); // 清除定时器
      }, 5 * 1000);
    },
    beforeDestroy() {
      // 清除定时器，防止内存泄露
      if (this.popupTimeout) {
        clearTimeout(this.popupTimeout);
      }
    },
  },
  created() {
    this.get_solution_list();
    this.get_case_list();

    //添加标题和meta标签
    let arr = [
      "首页",
      "产品中心",
      "解决方案",
      "客户案例",
      "新闻动态",
      "人才招聘",
      "关于我们",
      "联系我们",
    ];
    document.title = "首页-河北科瑞达仪器科技股份有限公司";
    let m = document.querySelectorAll("meta");
    const meta = document.createElement("meta");
    meta.name = "keywords";
    for (let i = 0; i < m.length; i++) {
      arr.some((item) => {
        if (item == m[i].content) {
          m[i].remove();
        }
      });
    }
    meta.content = "首页";

    m[0].after(meta);
    for (let i = 0; i < m.length; i++) {
      if (m[i].content == "河北科瑞达仪器科技股份有限公司") {
        m[i].remove();
      }
    }
  },
  mounted() {
    // 当组件被创建时，自动弹出窗口
    this.showPopup();
    //页面加载更新标题
    // document.title='首页-河北科瑞达仪器科技股份有限公司'
    // new Swiper("swiper", {
    //     effect: "coverflow",
    //     grabCursor: true,
    // 	centeredSlides: true,
    // 	slidesPerView: "auto",
    // 	autoplay: true,
    // 	loop: true,
    // 	initialSlide: 0,
    // 	coverflowEffect: {
    // 		rotate: 12,
    // 		stretch: 160,
    // 		depth: 20,
    // 		modifier: 1,
    // 		slideShadows: true
    // 	},
    // 	/* pagination: {
    // 	el: ".swiper-pagination",
    // 	} */
    // });

    // 监听滚动条
    window.addEventListener(
      "scroll",
      () => {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop > 20) {
          this.subnav_show = false;
        } else {
          this.subnav_show = true;
        }
      },
      true
    );
  },
  destroyed() {
    window.removeEventListener("scroll", () => {}, true);
  },
};
</script>
<style scoped>
/deep/ .container {
  width: 1200ox;
  margin: 20px auto 140px auto !important;
}

.services .el-row {
  width: 1295px;
  justify-content: center;
  margin: 0 !important;
}

.services .section-title {
  width: 1295px;
  text-align: center;
}

.services .el-row .el-col {
  width: 25%;
}

@import "../static/css/home.css";

.about_us {
  width: 1280px;
  height: auto;
  padding-bottom: 0px;
}

.about_us_more .name {
  margin-top: 0;
}

#home {
  min-width: 1100px;
  overflow-x: hidden;
}

.pcba_list {
  width: 1290px;
}

.services .icon-box {
  height: calc(100% - 60px);
}

.pcba_list_left {
  padding-top: 60px;
}

.pacb_option {
  margin-top: 140px;
}

.advantage .icon-box {
  padding: 60px 20px 0;
  min-height: 290px;
}

/deep/ .cases .case .case-info > div span::after {
  width: 0;
  display: none;
}

.case-info > h4 {
  max-width: 370px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cases .case {
  padding: 25px 25px;
}

.cases .case .more a:hover {
  color: #fff;
}

.cases .case .case-info {
  padding-left: 20px;
}

.case-info .more {
  margin-top: 48px;
}

.cases .case >>> p {
  margin-top: 5px;
}

.cases .case >>> span {
  padding-bottom: 8px;
}

.cases .case >>> h4 {
  margin-bottom: 15px;
}

.solutions .card-text {
  font-size: 14px;
}

.solutions .card:hover .card-text a {
  color: #fff;
}

#advantage .icon-box p {
  font-size: 14px;
}

.pcba_list_left .pcba_info {
  font-size: 14px;
}

.about_us_more .content > div {
  font-size: 14px;
}

.services .description {
  font-size: 14px;
}

#divAdd {
  background-color: #ededed;
  /*width: 100%;*/
  /*min-width: 1200px;*/
  width: 1000px;
  margin: 0px auto;
}

.divAdd-con {
  margin: 0px auto;
  width: 1000px;
  overflow: auto;
  padding: 30px 0px;
}

.divAdd-con img {
  float: left;
}

.indexrt {
  margin: 0px 40px;
}

.divAddleft img {
  float: left;
  margin-bottom: 7px;
}

.divAddleft {
  float: left;
  display: inline;
  width: 370px;
}

.divAddrt {
  float: right;
  display: inline;
  margin-top: 7px;
}

.back_add {
  width: 1280px;
  margin: 0 auto;
  background-color: #ededed;
}

.divAdd-con img {
  border: none;
}

a:focus,
a:hover {
  color: #23527c;
}

.threeImg {
  height: 145px;
  /* // border-bottom: 3px solid #4679b2; */
  min-width: 1280px;
}

.threeImg .Containt ul {
  margin: 0 auto;
  /* // padding: 0 97px; */
  width: 4000px;
  position: absolute;
  left: 0px;
  cursor: pointer;
  height: 100%;
}

.threeImg .Containt ul li {
  width: 236px;
  margin: 0 10px;
  margin-top: 10px;
  float: left;
}

.threeImg .Containt ul li img {
  height: 128px;
  width: 100%;
}

.Containt {
  position: relative;
  width: 1280px;
  height: 130px;
  /* // overflow-x: auto; */
  overflow: hidden;
  margin: 0 auto;
  /* // background-color: red; */
}

.iconleft {
  position: absolute;
  width: 20px;
  height: 80px;
  top: 30px;
  left: 10px;
  z-index: 99999;
  padding-top: 37px;
  background-color: #ddd;
  vertical-align: middle;
}

.iconright {
  position: relative;
  left: 977px;
  top: 70px;
  background-color: #ddd;
  /*position: absolute;*/
  width: 20px;
  height: 80px;
  top: 30px;
  z-index: 99999;
  padding-top: 37px;
  background-color: #ddd;
  vertical-align: middle;
}

.uls {
  margin: 0 50px;
}

/deep/#about .el-carousel__container {
  height: 350px;
}
/deep/#about .el-carousel__arrow {
  display: none;
}
/deep/#about .el-carousel__indicators {
  display: none;
}
/deep/#advantage .el-carousel__indicators {
  display: none;
}
/* /deep/#advantage .el-image{
	margin-right: 10px;
} */
/deep/#advantage .el-image__inner {
  width: 240px;
  height: 300px;
}
/deep/#advantage .el-image {
  width: 240px;
  height: 300px;
}
/deep/#advantage .el-carousel__item {
  display: flex;
  justify-content: space-between;
}
.swiper {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 300px;
  height: 300px;
  box-sizing: border-box;
}

.swiper-slide img {
  display: block;
  width: 100%;
}
:deep(.el-image__inner) {
  max-width: 100%;
  height: 350px;
}
.swiper-slide {
  height: auto;
}
.advantages {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.popup-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.popup-container div {
  display: block; /* 适当的样式，比如宽度、高度、对齐等 */
  width: 40%;
  position: relative;
}

.popup-container img {
  display: block; /* 适当的样式，比如宽度、高度、对齐等 */
  width: 100%;
  position: relative;
}

.popup-container button {
  position: absolute;
  top: 0;
  right: 0;
  /* float: right; */
  /* 样式调整，比如大小、颜色、hoever效果等 */
  background-color: red;
}

.popup-container button span {
  background-color: white;
}
</style>
